import React, { useMemo, useState } from 'react';

import { Spinner } from '@/components/Elements';
import { TableMenu } from '@/components/Elements/Menu';
import { Head } from '@/components/Head';
import { Table } from '@/components/Table';
import { formatDate, formatTransactionType } from '@/utils/functions';

import { useGetTransactions, useGetTransactionsStats } from '../hooks';

export const Transactions = () => {
  const [selectedType, setSelectedType] = useState<string>(''); // filter state

  const [userName, setUserName] = useState('');

  const [selectedStatus, setSelectedStatus] = React.useState('');
  const { data: transactions, isLoading } = useGetTransactions({
    type: selectedType || undefined,
    status: selectedStatus || undefined,
    user: userName || undefined,
  });
  const { data: transactionsStats } = useGetTransactionsStats();

  const handleEdit = (_id: string) => {
    console.log(_id);
  };

  const handleView = (_id: string) => {
    console.log(_id);
  };

  const handleDelete = (_id: string) => {
    console.log(_id);
  };

  const columns = useMemo(
    () => [
      {
        Header: '',
        id: 'menu',
        disableSortBy: true,
        Cell: ({ row }: any) => (
          <div className=''>
            <TableMenu
              _id={row.original._id}
              handleEdit={() => handleEdit(row.original)}
              handleDelete={() => handleDelete(row.original)}
              handleView={() => handleView(row.original)}
            />
          </div>
        ),
      },
      {
        Header: 'Transaction ID',
        accessor: 'transactionId',
      },
      {
        Header: 'Type',
        accessor: 'type',
        Cell: ({ value }: { value: string }) => (
          <span>{formatTransactionType(value)}</span>
        ),
      },
      {
        Header: 'Description',
        accessor: 'description',
      },
      {
        Header: 'Amount (₦)',
        accessor: 'amount',
      },
      {
        Header: 'User',
        Cell: ({ row }: any) => {
          return (
            <span>
              {row.original.user?.firstName} {row.original.user?.lastName}
            </span>
          );
        },
      },
      {
        Header: 'Date/ Time',
        Cell: ({ row }: any) => {
          return <span>{formatDate(new Date(row.original.createdAt))}</span>;
        },
        // accessor: 'createdAt',
      },
      {
        Header: 'Status',
        // accessor: 'status',
        Cell: ({ row }: any) => {
          return (
            <span
              className={
                row.original.status === 'COMPLETED'
                  ? 'text-green-500'
                  : 'text-red-500'
              }
            >
              {row.original.status}
            </span>
          );
        },
      },
    ],
    [],
  );

  return (
    <div>
      <Head title='Transactions' />
      {isLoading ? (
        <div className='flex h-screen justify-center items-center'>
          <Spinner size='md' />
        </div>
      ) : (
        <div className='overflow-hidden '>
          {transactionsStats && (
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 p-4'>
              {transactionsStats.map((stat: any, idx: number) => (
                <div
                  key={idx}
                  className='bg-white shadow-md rounded-xl p-4 border border-gray-200 hover:shadow-lg transition'
                >
                  <h3 className='text-lg font-semibold text-indigo-600 mb-2'>
                    {formatTransactionType(stat.type)}
                  </h3>
                  <p className='text-gray-700 text-sm mb-1'>
                    <span className='font-medium'>Count:</span> {stat.count}
                  </p>
                  <p className='text-gray-700 text-sm'>
                    <span className='font-medium'>Total Amount:</span>{' '}
                    {stat.totalAmount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </div>
              ))}
            </div>
          )}

          <div className='flex flex-wrap gap-4 px-4 mb-4'>
            {/* Filter by Name */}
            <div>
              <label
                htmlFor='name'
                className='block text-sm font-medium text-gray-700 mb-1'
              >
                Search by Name
              </label>
              <input
                id='user'
                type='text'
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                placeholder='Enter first or last name'
                className='border border-gray-300 rounded-md p-2 w-64'
              />
            </div>
            {/* Filter by Type */}
            <div>
              <label
                htmlFor='transactionType'
                className='block text-sm font-medium text-gray-700 mb-1'
              >
                Filter by Type
              </label>
              <select
                id='transactionType'
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
                className='border border-gray-300 rounded-md p-2 w-64'
              >
                <option value=''>All</option>
                {transactionsStats?.map((stat: any) => (
                  <option key={stat.type} value={stat.type}>
                    {formatTransactionType(stat.type)}
                  </option>
                ))}
              </select>
            </div>

            {/* Filter by Status */}
            <div>
              <label
                htmlFor='transactionStatus'
                className='block text-sm font-medium text-gray-700 mb-1'
              >
                Filter by Status
              </label>
              <select
                id='transactionStatus'
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                className='border border-gray-300 rounded-md p-2 w-64'
              >
                <option value=''>All</option>
                <option value='COMPLETED'>Completed</option>
                <option value='PENDING'>Pending</option>
                <option value='FAILED'>Failed</option>
              </select>
            </div>
          </div>

          <Table
            data={transactions ?? []}
            columns={columns}
            showPagination={true}
          />
        </div>
      )}
    </div>
  );
};
